import { MutationTypes } from "./mutation-types";
export const mutations = {
    [MutationTypes.UPDATE_VERSION](state, payload) {
        state.version = payload;
    },
};
